import { getObjectPropertyValue, isArrayNotEmpty, isFunction } from "functions";
import React, { useState } from "react";
import "./tabs.scss";

export function useTabs(props) {
    const {
        tabsDetails,
        defaultTabId,

        // Functions
        onClick = () => {},
        onTabIdChange = () => {}
    } = props;

    const [currentTabId, setCurrentTabId] = useState(defaultTabId);

    let tabsDisplay = [];
    if (isArrayNotEmpty(tabsDetails)) {
        tabsDisplay = tabsDetails.map((details, idx) => {
            let id = getObjectPropertyValue(details, "id");
            let text = getObjectPropertyValue(details, "text");
            let filters = getObjectPropertyValue(details, "filters");

            return (
                <div key={idx} className={"hook-tabs d-flex align-items-center justify-content-center " +
                        ((currentTabId === id)? "hook-tabs__current-tab ":"")}
                    onClick={() => {
                        setCurrentTabId(id);
                        onTabIdChange(id);
                        onClick(id, filters);
                    }}
                >
                    {text}
                </div>
            )
        })
    }

    return {
        tabsDisplay: (
            <div className={"d-flex"}>
                {tabsDisplay}
            </div>
        ),
        currentTabId
    };
}